import ReportWrapper from '../ReportWrapper'
import React from 'react'
import EnforcementCasesOverview from './EnforcementCasesOverview'
import ImplementationCases from './ImplementationCases'
import ReportSectionHeading from '../ReportSectionHeading'

interface EnforcementCasesProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function EnforcementCases({ data, title, sectionIndex }: EnforcementCasesProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <EnforcementCasesOverview data={data} />
      <ImplementationCases data={data} />
    </ReportWrapper>
  )
}
